module.exports = __webpack_public_path__ + "img/20161025_005722.3c0c0824.jpg";